import "chart.js/auto";
import BaseListPage from "../../../base/BaseListPage";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../usecases/object";
import DiscountDayWeekPresenter from "./DiscountDayWeekPresenter";
import withRouter from "../../../withRouter";
import printChart from "../../../PrintChart";
import Export from "../../../components/Export";
import DateRangeReport from "../../../components/DateRangeReport";
import Select from "react-select";
import DefaultState from "../../sales-and-transactions/components/DefaultState";
import InitialPrompt from "../../../components/InitialPrompt";
import DiscountByDayReport from "./components/DiscountByDayReport";
import { exportDiscountDayOfWeekCSV } from "./utils/discountDayOfWeekCsvUtils";
import {
  getDayOfWeekChartOptions,
  getDayOfWeekDiscountChartData,
} from "./utils/dayOfWeekChartUtils";
import ProgressLoader from "../../../components/ProgressLoader";

class DiscountDayWeekPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new DiscountDayWeekPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      startDate: "",
      endDate: "",
      selectedStoreCode: "",
      store: [],
      storess: "",
      range: "",
    };
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", "")
    );

    return [...new Set(storeCodes)];
  }

  handleStartDateChange(event) {
    this.setState({ startDate: event.target.value });
  }

  handleEndDateChange(event) {
    this.setState({ endDate: event.target.value });
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  filterTransactions() {
    const { objects, startDate, endDate, selectedStoreCode } = this.state;

    return objects.filter((transaction) => {
      const transactionDate = new Date(transaction.tran_date);
      const start = startDate
        ? new Date(startDate)
        : new Date(-8640000000000000);
      const end = endDate ? new Date(endDate) : new Date();
      end.setHours(23, 59, 59, 999);
      const isDateInRange =
        (!startDate || transactionDate >= start) &&
        (!endDate || transactionDate <= end);
      const isStoreCodeMatch = selectedStoreCode
        ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
          selectedStoreCode
        : true;

      return isDateInRange && isStoreCodeMatch;
    });
  }

  countTransactionTypesPerDayOfWeek = (transactions) => {
    const counts = {
      DineIn: new Array(7).fill(0),
      GrabFood: new Array(7).fill(0),
      TakeOut: new Array(7).fill(0),
    };

    transactions.forEach((transaction) => {
      const dayOfWeek = new Date(transaction.createdAt).getDay();
      switch (transaction.tran_type) {
        case "D": // Dine-in
          counts.DineIn[dayOfWeek]++;
          break;
        case "G": // GrabFood
          counts.GrabFood[dayOfWeek]++;
          break;
        case "T": // Take-out
          counts.TakeOut[dayOfWeek]++;
          break;
        default:
          break;
      }
    });

    return counts;
  };

  countDiscountAmountPerDayOfWeek = (transactions) => {
    const discountAmounts = new Array(7).fill(0);

    transactions.forEach((transaction) => {
      const dayOfWeek = new Date(transaction.tran_date).getDay();
      const discountAmount = Number(transaction.discount_amount) || 0; // Replace with the actual property name for the discount amount
      discountAmounts[dayOfWeek] += discountAmount;
    });

    return discountAmounts;
  };

  exportToCSV = () => {
    const { objects } = this.state;
    const filtered = this.filterTransactions(objects);
    exportDiscountDayOfWeekCSV(filtered);
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const { objects, selectedStoreCode, selectedYear, storess } = this.state;
    const filtered = this.filterTransactions(objects);
    const discountAmountsPerDay = this.countDiscountAmountPerDayOfWeek(
      filtered,
      new Date(this.state.startDate).getMonth(),
      new Date(this.state.startDate).getFullYear()
    );
    const chartData = getDayOfWeekDiscountChartData(discountAmountsPerDay);
    const chartOptions = getDayOfWeekChartOptions();
    const chartId = "chart-container19";

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
          <h2 className="fw-bold text-capitalize">
            <span style={{ color: "black" }}>Discount</span>
            <span style={{ color: "#83c14a" }}> Value</span>
            <span style={{ color: "black" }}> vs.</span>
            <span style={{ color: "#c5da55" }}> Day of Week</span>
          </h2>
          <Export
            exportCsv={this.exportToCSV}
            exportPdf={() => printChart(chartId)}
          />
        </div>

        <div className="row mb-2">
          <div className="col-sm-4" style={{ maxWidth: "max-content" }}>
            <DateRangeReport
              onChange={this.onChangeDate.bind(this)}
              field="tran_date"
            />
          </div>
          <div className="col-sm-4">
            <Select
              options={[
                ...this.state.store.map((code) => ({
                  value: code.name,
                  label: code.name,
                })),
              ]}
              onChange={(selected) => this.onChangeStore(selected.value)}
              isDisabled={!this.state.range}
              placeholder="Select Store"
              className="basic-single"
              classNamePrefix="select"
            />
          </div>
        </div>
        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 ? (
          <DiscountByDayReport
            chartData={chartData}
            chartOptions={chartOptions}
            storess={storess}
            chartRef={this.chartRef19}
            containerId="chart-container19"
          />
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess && this.state.range ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default withRouter(DiscountDayWeekPage);
